import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterScheduledMessage } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterScheduledMessageRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  message: MatterScheduledMessage;
  onDelete: () => void;
  onEdit: () => void;
  trigger: ReactNode;
};

export function MatterScheduledMessageRowContextMenu({
  canDelete,
  canEdit,
  message,
  onDelete,
  onEdit,
  trigger,
}: MatterScheduledMessageRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="scheduled message"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(message.label, "Message label");
            }}
          >
            <Clipboard />
            Copy message label
          </ContextMenuItem>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(message.content, "Message content");
            }}
          >
            <Clipboard />
            Copy message content
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
